import * as api from './api'
import moment from 'moment/moment'


export default {
  async loadData ({ commit }, date = null) {
    const DEFAULT_DATE = [
      moment().startOf('month').format('DD.MM.YYYY'),
      moment().format('DD.MM.YYYY')
    ]

    const { data } = await api.loadData(date || DEFAULT_DATE) || {}

    if (data?.code === 200) {
      commit('setData', data.data)
      commit('setLastDateUpdated')

      return { data: data.data }
    }

    return { error: data.data }
  },
  async loadDataByOpenedWorkingShift ({ rootGetters }) {
    const workingShiftId = rootGetters['workingShift/getOpenedWorkingShift']?.id

    if (!workingShiftId) {
      return { error: { text: 'Отсутствуют данные смены' } }
    }

    const { data } = await api.loadDataByWorkingShift(workingShiftId) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data?.code }
  },
  async getReturnedSales (_, payload) {
    const { userId, dateRange } = payload || {}
    const { data } = await api.getReturnedSales(userId, dateRange) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data?.code }
  },
  async getByDateAndUserId (_, payload) {
    const { userId, dateRange } = payload || {}
    const { data } = await api.getByDateAndUserId(dateRange, userId) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data?.code }
  },
  async create ({ commit, state }, payload) {
    const { data } = await api.create(payload) || {}

    if (data?.code === 200) {
      const newData = state.data

      newData.unshift(data.data)

      commit('setData', newData)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async change ({ commit, state }, payload) {
    const { id, data: payloadData } = payload || {}
    const { data } = await api.change(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = data.data
        }

        return item
      })

      commit('setData', newData)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async return ({ commit, state }, id) {
    const { data } = await api.returnSale(id) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = data.data
        }

        return item
      })

      commit('setData', newData)

      return { data: newData }
    }

    return { error: data.data }
  },
  async remove ({ commit, state }, payload) {
    const { data } = await api.remove(payload) || {}

    if (data?.code === 200) {
      const newData = state.data.filter(({ id }) => id !== payload )

      commit('setData', newData)

      return { data: newData }
    }

    return { error: data.data }
  }
}